// eslint-disable-next-line import/prefer-default-export
export const config = {
  SHOP_BACKEND_HOST:
    process.env.GATSBY_SHOP_BACKEND_HOST || "http://ew-shop.test",
  MAILING_BACKEND_HOST: process.env.GATSBY_MAILING_BACKEND_HOST,
  GOOGLE_MAP_API_KEY: process.env.GATSBY_GOOGLE_MAP_API_KEY,
  ENVIRONMENT: process.env.GATSBY_ENVIRONMENT || "development",
  BRAND: "E&W Burgers",
  COMPANY: "PT. Citarasa Kreatif Indonesia",
  WA: "6285210402299",
  SOCIAL: {
    INSTA: "https://www.instagram.com/ewburgers",
    FB: "https://www.facebook.com/ewburgers",
    TIKTOK: "https://www.tiktok.com/@ewburgers",
  },
  STOREFRONT_DOMAIN: "https://shop.ewburgers.com",
};
